/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {ChangeEvent, Ref} from 'react';
import * as styled from 'styled-components';
import {theme, paddings} from 'components/shared/theme';

export interface IInput {
  error?: boolean;
  type?: 'password' | 'number' | 'text' | 'email' | 'username' | 'name' | 'search';
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  name?: string;
  placeholder?: string;
  id?: string;
  ref?: Ref<HTMLInputElement>;
}

const {
  colors,
  primaryBorderColor,
  primaryBorderRadius,
  primaryFontSize,
  primaryLineHeight,
  primaryInputHeight
} = theme;

export const Input = styled.default.input<IInput>`
  background-color: ${colors.white};
  border: 1px solid ${primaryBorderColor};
  border-radius: ${primaryBorderRadius};
  display: block;
  font-size: ${primaryFontSize};
  height: ${primaryInputHeight};
  line-height: ${primaryLineHeight};
  outline: none;
  padding: ${paddings.small};
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  background-position: 1rem center;
  background-repeat: no-repeat;
  width: inherit;
  ${({error}) => error && styled.css`
    border-color ${colors.lightRed};
  `}
`;